/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/radio/custom-elements';

import { defineCustomElement as defineOsdsRadio } from '@ovhcloud/ods-stencil/components/radio/custom-elements/osds-radio.js';
import { defineCustomElement as defineOsdsRadioGroup } from '@ovhcloud/ods-stencil/components/radio/custom-elements/osds-radio-group.js';


export const OsdsRadio = /*@__PURE__*/ defineContainer<JSX.OsdsRadio>('osds-radio', defineOsdsRadio, [
  'ariaLabel',
  'ariaLabelledby',
  'save',
  'beforeSave',
  'afterSave',
  'checked',
  'checking',
  'disabled',
  'label',
  'name',
  'value',
  'odsValueChange',
  'odsCheckedChange',
  'odsCheckingChange',
  'odsFocus',
  'odsBlur'
]);


export const OsdsRadioGroup = /*@__PURE__*/ defineContainer<JSX.OsdsRadioGroup>('osds-radio-group', defineOsdsRadioGroup, [
  'name',
  'value',
  'disabled',
  'save',
  'beforeSave',
  'afterSave',
  'required',
  'odsValueChange',
  'odsDisabledChange'
]);

